// extracted by mini-css-extract-plugin
export default {"root":"DeleteConfigModal_root__6ytT9","container":"DeleteConfigModal_container__wpR9s"};